import React, { useEffect, useCallback } from 'react';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import {
  setRowsFiltersForTicketHistoric,
  rowsFiltersForTicketHistoricState,
  sortConfigState,
  setSortConfigForTicketHistoric,
} from '../WagonDetailsPage/WagonDetailsPageSlice';
import {
  currentViewNameState,
  userPreferencesState,
  setRowsFiltersForCurrentTicketList,
  setSortConfig,
} from '../HomePage/TicketList/TicketListSlice';
import { selectedMenuTabState } from '../HomePage/ContentTabs/ContentTabsSlice';
import {
  rowsFiltersForWorkshopTimeState,
  sortConfigForWorkshopTimeState,
  setRowsFiltersForWorkshopTime,
  setSortConfigForWorkshopTime,
} from '../WorkshopTimePage/WorkshopTimeSlice';
import useStyles from './styles';
import MultiSelect from './MultiSelect';

export default function FilterPopper(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const lang = i18n.language;
  const { initialAnchorEl, placement, rows, selectedCell } = props;
  const [options, setOptions] = React.useState([]);
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const selectedTicketTable = useSelector(selectedMenuTabState);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const currentViewName = useSelector(currentViewNameState);
  const userPreferences = useSelector(userPreferencesState);
  const [defaultOrder, setDefaultOrder] = React.useState('desc');
  const { rowsFilters, sortConfig } = userPreferences.find(
    (userPreference) => userPreference.viewName === currentViewName,
  );
  const rowsFiltersForTicketHistoric = useSelector(
    rowsFiltersForTicketHistoricState,
  );
  const rowsFiltersForWorkshopTime = useSelector(
    rowsFiltersForWorkshopTimeState,
  );
  const sortConfigTicketHistoric = useSelector(sortConfigState);
  const sortConfigWorkshopTime = useSelector(sortConfigForWorkshopTimeState);
  const [defaultOptions, setDefaultOptions] = React.useState([]);
  const [defaultSortConfig, setDefaultSortConfig] = React.useState([]);

  const { t } = useTranslation();

  const sortBy = useCallback(
    (propertyName) => {
      let pendingChange = defaultSortConfig.slice();
      const index = pendingChange.findIndex(
        (config) => config.propertyName === propertyName,
      );
      if (index > -1) {
        const currentSortType = pendingChange[index].sortType;
        pendingChange.splice(index, 1);
        if (currentSortType === 'desc') {
          pendingChange = [...pendingChange, { propertyName, sortType: 'asc' }];
        } else {
          pendingChange = [
            ...pendingChange,
            { propertyName, sortType: 'desc' },
          ];
        }
      } else {
        pendingChange = [...pendingChange, { propertyName, sortType: 'desc' }];
      }
      if (selectedTicketTable === 'ticketHistoric') {
        dispatch(setSortConfigForTicketHistoric([...pendingChange]));
      } else if (selectedTicketTable === 'ticketList') {
        dispatch(setSortConfig([...pendingChange]));
      } else {
        dispatch(setSortConfigForWorkshopTime([...pendingChange]));
      }
    },
    [defaultSortConfig],
  );

  useEffect(() => {
    setDefaultOptions(
      selectedTicketTable === 'ticketHistoric'
        ? rowsFiltersForTicketHistoric
        : selectedTicketTable === 'ticketList'
        ? rowsFilters
        : rowsFiltersForWorkshopTime,
    );
    const defaultConfig =
      selectedTicketTable === 'ticketHistoric'
        ? sortConfigTicketHistoric
        : selectedTicketTable === 'ticketList'
        ? sortConfig
        : sortConfigWorkshopTime;
    setDefaultSortConfig(defaultConfig);
    let defaultSortType = 'desc';
    const defaultConfigSelected = defaultConfig.find(
      (config) => config.propertyName === selectedCell,
    );
    if (defaultConfigSelected) {
      defaultSortType = defaultConfigSelected.sortType;
    }
    setDefaultOrder(defaultSortType);
  }, [
    selectedCell,
    selectedTicketTable,
    rowsFiltersForTicketHistoric,
    rowsFilters,
    rowsFiltersForWorkshopTime,
    sortConfigTicketHistoric,
    sortConfig,
    sortConfigWorkshopTime,
  ]);

  useEffect(() => {
    const defaultSelectedOptions = defaultOptions.find(
      (item) => item.cell === selectedCell,
    );
    if (defaultSelectedOptions) {
      const translatedSelectedOption = [];
      defaultSelectedOptions.selectedOptions.forEach((selectedOption) =>
        translatedSelectedOption.push(t(selectedOption)),
      );
      setSelectedOptions(translatedSelectedOption);
    } else {
      setSelectedOptions([]);
    }
  }, [defaultOptions, selectedCell, lang]);

  const handleClickAway = () => {
    setOpen(false);
    setAnchorEl(null);
    props.sendAnchorEl();
  };
  useEffect(() => {
    setAnchorEl(initialAnchorEl);
    setOpen(Boolean(initialAnchorEl));
  }, [initialAnchorEl]);

  useEffect(() => {
    setOptions([
      ...new Set(
        rows.map((row) => {
          return t(row[selectedCell]);
        }),
      ),
    ]);
  }, [selectedCell, rows, lang]);

  function onTagsChange(event, values) {
    if (values) {
      const optionsPerCell = {};
      optionsPerCell.cell = selectedCell;
      const translatedSelectedOption = [];
      values.forEach((value) => translatedSelectedOption.push(t(value)));
      optionsPerCell.selectedOptions = translatedSelectedOption;
      if (selectedTicketTable === 'ticketHistoric') {
        dispatch(setRowsFiltersForTicketHistoric(optionsPerCell));
      } else if (selectedTicketTable === 'ticketList') {
        const rowsFiltersForCurrentTicketList = {};
        rowsFiltersForCurrentTicketList.currentTicketList = currentViewName;
        rowsFiltersForCurrentTicketList.optionsPerCell = optionsPerCell;
        dispatch(
          setRowsFiltersForCurrentTicketList(rowsFiltersForCurrentTicketList),
        );
      } else {
        dispatch(setRowsFiltersForWorkshopTime(optionsPerCell));
      }
    }
  }
  const handleToggleOption = (option) => setSelectedOptions(option);
  const handleClearOptions = () => setSelectedOptions([]);
  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      setSelectedOptions(options);
    } else {
      handleClearOptions();
    }
  };
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Popper open={open} anchorEl={anchorEl} placement={placement}>
        <Paper className={classes.paperPopper}>
          <div
            role="button"
            tabIndex={0}
            className={classes.container}
            onClick={() => sortBy(selectedCell)}
            onKeyDown={() => sortBy(selectedCell)}
          >
            <TableSortLabel
              classes={{
                icon: classes.filterIcon,
              }}
              active
              direction={defaultOrder}
            />
            <span className={classes.filterText}>
              {defaultOrder === 'desc' ? t('descending') : t('ascending')}
            </span>
          </div>
          <MultiSelect
            items={options}
            fieldName={selectedCell}
            classes={classes}
            selectedValues={selectedOptions}
            onToggleOption={handleToggleOption}
            onClearOptions={handleClearOptions}
            onSelectAll={handleSelectAll}
            onChange={onTagsChange}
          />
        </Paper>
      </Popper>
    </ClickAwayListener>
  );
}
